export default {
  arrivalBreakTolerance: 0,
  contractIds: [],
  contracts: [],
  departureBreakTolerance: 0,
  exitTolerance: 0,
  lunchCheck: false,
  lunchTime: '',
  name: '',
  shiftDaysAttributes: [],
  shiftType: 'weekly',
  startDate: '',
  tolerance: 0,
  workHolidays: false
};
